import { useMemo } from "react";
import { useUser } from "@auth0/nextjs-auth0/client";

import type { CustomUserProfile } from "@src/types/user";
import { plans } from "@src/utils/plans";

type UseCustomUser = {
  user: CustomUserProfile | undefined;
  isLoading: boolean;
  error: Error | undefined;
  checkSession: () => Promise<void>;
};

/**
 * Returns information about registered user.
 */
export const useCustomUser = (): UseCustomUser => {
  const { user, isLoading, error, checkSession } = useUser();
  const completeUser = useMemo(() => (user ? { ...user, plan: plans.find(x => x.code === user.planCode) } : user), [user]);

  return {
    user: completeUser,
    isLoading,
    error,
    checkSession
  };
};
